export enum ComponentFieldEnum {
    HideInInspector,
    Number,
    String,
    Boolean,
    Vector2,
    Vector3,
    Border,
    Layout,
}